// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__DJDMv","overlay":"Modal_overlay__r63M6","content":"Modal_content__gGb69","cross":"Modal_cross__5k9Me"};